/**
 * 权限指令
 * 使用方式：
 * <button v-permission="'product:manage'">添加商品</button>
 * <button v-permission="['product:manage', 'product:edit']">编辑商品</button>
 */

import { hasPermission, hasAnyPermission } from '@/utils/permission';

export default {
  bind: function (el, binding) {
    const { value } = binding;
    
    if (value) {
      let hasAccess = false;
      
      // 支持单个权限或权限数组
      if (typeof value === 'string') {
        hasAccess = hasPermission(value);
      } else if (Array.isArray(value)) {
        hasAccess = hasAnyPermission(value);
      }
      
      // 如果没有权限，移除元素
      if (!hasAccess) {
        if (el.parentNode) {
          el.parentNode.removeChild(el);
        }
      }
    }
  }
};
